import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "@/routes";
import { Toasts } from "@/components/Toasts";
import { RippleLayer } from "@/components/Ripple";
import { useOnline } from "@/hooks/useApp";
import { useRealtime } from "@/hooks/useRealtime";
import { useViewportInsets } from "@/hooks/useViewport";
import { usePrefs } from "@/lib/store";
import { registerServiceWorker } from "@/lib/pwa";
import { setupAppPlugin, setupKeyboard, setupStatusBar } from "@/lib/native";

function useThemeSync(): void {
  const theme = usePrefs((s) => s.theme);
  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      const dark = theme === "dark" || (theme === "system" && media.matches);
      document.documentElement.dataset.theme = dark ? "dark" : "light";
      document.documentElement.style.colorScheme = dark ? "dark" : "light";
    };
    apply();
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, [theme]);
}

function useDensitySync(): void {
  const density = usePrefs((s) => s.density);
  useEffect(() => {
    document.documentElement.dataset.density = density === "compact" ? "compact" : "comfortable";
  }, [density]);
}

/** Efeitos globais: tema, densidade, conexao, realtime e plugins nativos. */
function Bootstrap(): null {
  useThemeSync();
  useDensitySync();
  useOnline();
  useRealtime();
  useViewportInsets();

  useEffect(() => {
    registerServiceWorker();
    void setupStatusBar();
    void setupKeyboard();
    void setupAppPlugin(() => window.history.back());
  }, []);

  return null;
}

export function App() {
  return (
    <>
      <Bootstrap />
      <RippleLayer />
      <RouterProvider router={router} />
      <Toasts />
    </>
  );
}
